// extracted by mini-css-extract-plugin
export default {"nav":"profile_nav__-M+2g"};